document.addEventListener("DOMContentLoaded", function () {
  const checkButton = document.getElementById("check-edd");

  checkButton.addEventListener("click", async function () {
    const pincodeInput = document.getElementById("pincode-input").value.trim();
    const triggerTextElement = document.getElementById("check-delivery-time");

    if (!pincodeInput || pincodeInput.length !== 6 || isNaN(pincodeInput)) {
      alert("Please enter a valid 6-digit pincode.");
      return;
    }

    try {
      const pincodeKey = String(pincodeInput);

      const response = await fetch(
        "https://cdn.shopify.com/s/files/1/0729/1561/6066/files/edd_updated.json?v=1735367896"
      );
      const pincodeData = await response.json();

      const pincodeDetails = pincodeData[pincodeKey];

      if (!pincodeDetails) {
        triggerTextElement.innerHTML =
          "Delivery not available for this pincode, please contact our customer delight manager at 7827832027.";
        return;
      }

      const { eddDays, expressDelivery } = pincodeDetails;

      const now = new Date();
      const currentHour = now.getHours();

      let startDate = new Date(now);
      startDate.setDate(now.getDate() + eddDays - (currentHour < 12 ? 1 : 0));

      let endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 1);

      const formatDate = (date) => {
        const day = date.getDate();
        const month = date.toLocaleString("en-US", { month: "short" });
        const weekday = date.toLocaleString("en-US", { weekday: "short" });
        const suffix =
          day % 10 === 1 && day !== 11
            ? "st"
            : day % 10 === 2 && day !== 12
            ? "nd"
            : day % 10 === 3 && day !== 13
            ? "rd"
            : "th";
        return `${weekday}, ${day}${suffix} ${month}`;
      };

      const formattedStartDate = formatDate(startDate);
      const formattedEndDate = formatDate(endDate);

      let deliveryHours = eddDays === 1 ? "24 hours" : `${24 * eddDays} hours`;

      const resultHTML = `
        <ul class="result-text">
          <li>
            Free Delivery Between 
             <span class="highlight">${formattedStartDate} - ${formattedEndDate}</span>
          </li>
          ${
            expressDelivery
              ? '<li><span class="highlight">2-Hours Express Delivery</span> in just ₹299(09:30 a.m - 06:30 p.m)</li>'
              : ""
          }
        </ul>
        <div class="delivery-note" style="color: #616060; font-size: 12px; margin-top: 10px;">
          Note: Select from delivery options at checkout.
        </div>
      `;

      triggerTextElement.innerHTML = resultHTML;
    } catch (error) {
      console.error("Error calculating delivery date:", error);
      triggerTextElement.textContent =
        "Unable to fetch delivery date. Please contact our customer delight manager at 7827832027.";
    }
  });
});
